import React from "react";
import { Instant } from "@js-joda/core";
import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import { DataDisplayType, ValueChangeIndicatorProps } from "./ValueChangeIndicatorTypes";
import DatasetValue from "./DatasetValue";

const SumOfValues = (
  props: ValueChangeIndicatorProps & {
    dataRange?: DatasetDataInfoResponse[];
    refTime: Instant;
    diffDecimalPlaces?: number;
    setDialog: (isVisible: boolean) => void;
  }
) => {
  if (!props.dataRange || props.dataDisplayType !== DataDisplayType.SUM_OF_VALUES) return null;

  if (props.dataRange?.length > 1) {
    return (
      <div>
        <div className={`value-column ${props.displayInline ? "inline-values" : "column-values mt-2"} `}>
          {props.hideIfValueIsZeroOrMore &&
          props.dataRange[0].data[0].value &&
          props.dataRange[0].data[0].value >= 0
            ? null
            : props.dataRange.map((dataset: DatasetDataInfoResponse) => (
                <DatasetValue
                  key={dataset.identifier}
                  {...props}
                  dataset={dataset}
                  setDialog={props.setDialog}
                  refTime={props.refTime}
                  skipMonthCheck={props.skipMonthCheck}
                  diffDecimalPlaces={props.diffDecimalPlaces}
                />
              ))}
        </div>
      </div>
    );
  }
  return (
    <DatasetValue
      {...props}
      dataset={props.dataRange[0]}
      setDialog={props.setDialog}
      refTime={props.refTime}
    />
  );
};

export default SumOfValues;
